import { jsPDF } from 'jspdf'
import QRCode from 'qrcode'
import type { Product } from '../types'

const COLS = 3
const ROWS = 4
const PAGE_MARGIN = 12
const CELL_PADDING = 6
const QR_MM = 35
const LABEL_MM = 10

function getCellWidth(pageWidth: number): number {
  return (pageWidth - 2 * PAGE_MARGIN) / COLS
}

function getCellHeight(): number {
  return QR_MM + LABEL_MM + CELL_PADDING * 2
}

const A4_WIDTH_MM = 210

export async function exportProductsToPdf(products: Product[], filename = 'grocery-qr-codes.pdf'): Promise<void> {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })
  const pageWidth = A4_WIDTH_MM
  const cellW = getCellWidth(pageWidth)
  const cellH = getCellHeight()

  let row = 0
  let col = 0

  for (let i = 0; i < products.length; i++) {
    const p = products[i]
    if (!p) continue
    const x = PAGE_MARGIN + col * cellW + CELL_PADDING
    const y = PAGE_MARGIN + row * cellH + CELL_PADDING

    const dataUrl = await QRCode.toDataURL(p.qrCodeValue, { width: 256, margin: 0 })
    doc.addImage(dataUrl, 'PNG', x, y, QR_MM, QR_MM)

    const labelY = y + QR_MM + 4
    doc.setFontSize(9)
    doc.text(p.name.substring(0, 22), x, labelY, { maxWidth: cellW - 12 })

    col++
    if (col >= COLS) {
      col = 0
      row++
    }
    if (row >= ROWS) {
      doc.addPage()
      row = 0
    }
  }

  doc.save(filename)
}
